import { graphql } from 'react-relay';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { QueryInteropSupportedResult } from '@confluence/apollo-relay-interop/entry-points/query.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import type {
	getConsumptionEventDataQuery$data,
	getConsumptionEventDataQuery$variables,
} from './__generated__/getConsumptionEventDataQuery.graphql.ts';

export const loadSpaceAndContentData = async (
	spaceKey: string,
	contentId: string | undefined,
): Promise<QueryInteropSupportedResult<getConsumptionEventDataQuery$data>> => {
	if (!contentId) {
		return Promise.reject(new Error('Content ID is required'));
	}

	const response = await queryInterop<
		getConsumptionEventDataQuery$data,
		getConsumptionEventDataQuery$variables
	>({
		query: graphql`
			query getConsumptionEventDataQuery($spaceKey: String!, $contentId: ID!) {
				space(key: $spaceKey) {
					id
					type
					status
				}
				singleContent(id: $contentId) {
					id
					status
					type
					subType
				}
			}
		`,
		variables: { spaceKey, contentId },
	});

	// this is a workaround to handle the case where the content is restricted
	if (!response.error && response?.data?.singleContent === null) {
		return Promise.reject('singleContent is null');
	}

	return response;
};
